import { TeamLogo } from "./team-logo.model";

export class TeamLogoMapper {
  public static map(teamData: any): TeamLogo {
    if (!teamData) {
      return null;
    }

    if (!teamData.path) {
      return null;
    }

    return new TeamLogo(
      teamData.originalName,
      teamData.path,
      teamData.height,
      teamData.width,
      teamData.size,
      teamData.mimeType,
    );
  }
}
